import reduxThunk from 'redux-thunk';
import reduxHotjar from 'redux-hotjar';

import createMetricsMiddleware from './createMetricsMiddleware';
import createAnalyticsMiddleware from './createAnalyticsMiddleware';
import createPrestoLoggingMiddleware from './createPrestoLoggingMiddleware';
import createMissingImpressionMiddleware from './createMissingImpressionMiddleware';
import createSolTrackingMiddleware from './createSolTrackingMiddleware';
import { metricsIsEnabled } from 'src/config';

const staticMiddleware = [
  reduxHotjar(),
  reduxThunk,
  ...(metricsIsEnabled ? [createMetricsMiddleware()] : [])
];
const prestoLoggingMiddleware = createPrestoLoggingMiddleware();

export default ({ analytics }) => {
  return [
    ...staticMiddleware,
    ...[createAnalyticsMiddleware({ analytics })],
    prestoLoggingMiddleware,
    createMissingImpressionMiddleware(),
    createSolTrackingMiddleware()
  ];
};
